import { createContext, useContext } from 'react';

export const FULL_SCREEN_Z_INDEX = 999;

type ContextType = {
    isFullScreen: boolean;
    toggleIsFullScreen: () => void;
};

const initialContext: ContextType = {
    isFullScreen: false,
    toggleIsFullScreen: () => {},
};

export const FullScreenContext = createContext<ContextType>(initialContext);

export const useFullScreen = () => {
    return useContext(FullScreenContext);
};
